import { Component } from "@angular/core";
import { ReportPageBase } from "../components/report-page-base";
import { NotificationService } from "../../core/services/notification.service";
import { AppService } from "../../app.service";
import { NotificationType } from "../../core/services/notification-type";
import { saveAs } from 'file-saver';
import { ReportsService } from "../../shared/services/reports.service";

@Component({
	selector: 'sms-notifications-period-report-page',
	templateUrl: './sms-notifications-period-report.page.html',
	styleUrls: [
		'./sms-notifications-period-report.page.scss',
		'../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
	]
})
export class SmsNotificationsPeriodReportPage extends ReportPageBase {

	constructor(
		private reportsService: ReportsService,
		private notificationService: NotificationService,
		private appService: AppService
	) {
		super();
		appService.pageTitle = 'Отчёт. SMS-уведомления';
	}

	generateReport() {
		this.generateReportByDateRange((startDate, endDate) => {
			this.reportsService.getSmsNotificationsPeriod(startDate, endDate)
				.subscribe(blob => {
					if (blob.type === 'application/octet-stream') {
						const nowDate = new Date();
						saveAs(blob, `Отчет_SMS_уведомления_${nowDate.toLocaleDateString()}_${nowDate.getHours()}_${nowDate.getMinutes()}_${nowDate.getSeconds()}.xlsx`);
						this.dataGenerating = false;
					} else if (blob.type === 'application/json') {
						blob
							.text()
							.then(result => {
								const response = JSON.parse(result);
								if (!response.isSuccessful) {
									this.notificationService.error({
										title: 'Ошибка',
										message: response.errorDescription as string,
										notificationType: NotificationType.SweetAlert
									});
								}
								this.dataGenerating = false;
							});
					} else {
						this.dataGenerating = false;
					}
				}, () => {
					this.dataGenerating = false;
				});
		});
	}
}
